<div class="romeo-spinner" *ngIf="show">
        .
        <img src="../../../../assets/images/loader-romeo.gif" alt="" class="loader loader__img w-100">
        <!-- <div class="loader__text">loading.....</div> -->
</div>